import React from 'react';

import Typography from '@mui/material/Typography';

import {
	createTheme,
	responsiveFontSizes,
	ThemeProvider,
	StyledEngineProvider
} from '@mui/material/styles';

let theme = createTheme();
theme = responsiveFontSizes(theme);

export default function Title({ children }) {
	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={theme}>
				<Typography variant="h5" color="primary" gutterBottom>
					{children}
				</Typography>
			</ThemeProvider>
		</StyledEngineProvider>
	);
}
